const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

export const validateLoginForm = (data) => {
  const errors = {};
  if (!data.email?.trim()) {
    errors.email = "Email is required.";
  } else if (!emailRegex.test(data.email)) {
    errors.email = "Email is invalid.";
  }
  if (!data.password) {
    errors.password = "Password is required.";
  }
  return errors;
};
